import { render, staticRenderFns } from "./LabItemParametro.vue?vue&type=template&id=6dc2bdc8&"
import script from "./LabItemParametro.vue?vue&type=script&lang=js&"
export * from "./LabItemParametro.vue?vue&type=script&lang=js&"
import style0 from "./LabItemParametro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports